import * as React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { isNewUi } from '../../redesign/uiMode';
import { LOOKUP_CANCEL, lookupDialogProps } from '../../redesign/shell/lookupCancel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom in={true} ref={ref} {...props} />;
});

export class ClientLookup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selectedRowId: null,
            inProgress: false,
        };

        this.fetchTries = 0;
        this.checkbox_clickHandler = this.checkbox_clickHandler.bind(this);
        this.close_clickHandler = this.close_clickHandler.bind(this);
        this.cancel_clickHandler = this.cancel_clickHandler.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { openDialog, fetchClientData } = this.props.info;
        if (openDialog && !this.state.inProgress) {
            if (prevProps.info.openDialog !== openDialog) {
                this.setState({ inProgress: true, data: [] }, () => {
                    this.fetchClients();
                    this.props.info.inProgress(true);
                });
            }
        }

        if (prevProps.info.fetchClientData !== fetchClientData && !fetchClientData) {
            this.setState({ data: [] });
        }
    }

    fetchClients() {
        this.fetchTries += 1;
        const clientCode = this.props.info.invoiceModel.clientCode;
        const selectedClientCode = this.props.info.invoiceModel.selectedClientCode;
        const url = `/api/lookup/client?clientCode=${encodeURIComponent(clientCode)}`;

        httpGet(url)
            .then((response) => {
                const data = response.data.map((row, index) => ({ ...row, rowId: index + 1 }));
                const selectedClientCode = this.props.info.invoiceModel.selectedClientCode;

                if (selectedClientCode) {
                    const index = data.findIndex(r => r.clientCode === selectedClientCode);

                    if (index !== -1) {
                        const selectedRow = data.splice(index, 1)[0];
                        data.unshift(selectedRow);

                        data.forEach((row, i) => row.rowId = i + 1);
                    }
                }
                const selectedRow = this.props.info.shouldSelectClient
                    ? data.find(row => row.clientCode === selectedClientCode)
                    : null;

                this.setState({
                    data,
                    selectedRowId: selectedRow ? selectedRow.rowId : null,
                    inProgress: false,
                });

                this.props.info.inProgress(false);
            })
            .catch((error) => {
                this.props.info.inProgress(false);
                this.setState({ inProgress: false });
                toast.error('An error occurred while fetching the records');
            });
    }

    checkbox_clickHandler(event) {
        const selectedRowId = parseInt(event.target.value, 10);
        this.setState((prevState) => ({
            selectedRowId: prevState.selectedRowId === selectedRowId ? null : selectedRowId,
        }));
    }

    close_clickHandler(event) {
        const { selectedRowId, data } = this.state;
        const selectedClient = data.find((row) => row.rowId === selectedRowId);

        if (this.props.onClose) {
            this.props.onClose(event, selectedClient || null);
        }
    }

    // New UI: close without applying (Cancel, ✕ and Escape).
    cancel_clickHandler(event) {
        if (this.props.onClose) {
            this.props.onClose(event, LOOKUP_CANCEL);
        }
    }

    render() {
        const openDialog = this.props.info?.openDialog || false;
        const { selectedRowId } = this.state;
        const newUi = isNewUi();

        return (
            <Dialog open={openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg" {...lookupDialogProps(newUi)}>
                <DialogTitle>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Select Client</span>
                        <IconButton
                            aria-label="close"
                            onClick={newUi ? this.cancel_clickHandler : this.close_clickHandler}
                            style={{
                                position: "relative",
                                right: '-1.5%',
                                float: "right",
                                top: '10%',
                                color: (theme) => theme.palette.grey[500]
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
                        <EnhancedDataGrid
                            rows={this.state.data}
                            disableColumnMenu
                            pagination
                            pageSize={10}
                            columns={[
                                {
                                    headerName: ' ',
                                    field: 'chkClient',
                                    width: 40,
                                    resizable: false,
                                    sortable: false,
                                    renderCell: (rowData) => (
                                        <Checkbox
                                            color="default"
                                            name="chk"
                                            checked={selectedRowId === rowData.row.rowId}
                                            value={rowData.row.rowId}
                                            onClick={this.checkbox_clickHandler}
                                        />
                                    ),
                                },
                                {
                                    headerName: 'Client Code',
                                    field: 'clientCode',
                                    flex: 0.3,
                                },
                                {
                                    headerName: 'Client Name',
                                    field: 'clientName',
                                    flex: 0.4,
                                },
                            ]}
                            getRowId={(row) => row.rowId}
                            disableSelectionOnClick
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    {newUi ? <Button onClick={this.cancel_clickHandler} data-apw2-dismiss="true">Cancel</Button> : null}
                    <Button autoFocus onClick={this.close_clickHandler} color="primary">
                        {newUi && selectedRowId != null ? 'Select' : 'Close'}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}